import { render, staticRenderFns } from "./Deopsit.vue?vue&type=template&id=a3f6c912&scoped=true"
import script from "./Deopsit.vue?vue&type=script&lang=js"
export * from "./Deopsit.vue?vue&type=script&lang=js"
import style0 from "./Deopsit.vue?vue&type=style&index=0&id=a3f6c912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f6c912",
  null
  
)

export default component.exports